export const LINK_RELEASE_NOTES = 'https://releases.demostack.com/';

export const BROWSER_WINDOW_HOME_PAGE = 'https://www.google.com/';
export const getBrowserWindowSearchPage = (searchValue: string) =>
  `https://www.google.com/search?q=${searchValue}`;

export const URLS_TO_IGNORE = [
  'https://www.google.com/uviewer',
  'https://appetize.io/',
  'https://contacts.google.com/widget/hovercard/',
];

export const containsIgnoredURL = (url: string) => {
  return URLS_TO_IGNORE.some((ignoredURL) => url.includes(ignoredURL));
};

export const VISIT_KEY = 'visit';
export const CLICK_KEY = 'click';

export const DAY_IN_MS = 24 * 60 * 60 * 1000;
export const MB_IN_BYTES = 1024 * 1024;
export const GB_IN_BYTES = 1024 * MB_IN_BYTES;

// key in user me state
export const SHOULD_SHOW_AFTER_LOGIN_MODAL_KEY = 'shouldShowAfterLoginModal';

export const X_DS_EXTERNAL_TRACK_ID = 'x-ds-external-track-id';
